(function() {

  'use strict';

  function OrcamentoResource($resource, URL, PATH) {
    return $resource(URL + PATH + '/orcamento', {},  
    {
      postOrcamento: {
        method: 'POST',
        url: URL + PATH + '/orcamento',
        isArray: true
      }
    });
  };

  angular.module('mandaeApp')
    .factory('OrcamentoResource', OrcamentoResource);

})();
